import {Concept} from 'types';
import type {PreviewConfiguration} from 'schema/types';
import type {SchemaReference} from 'schemas/types';
import type {ExpressionV4} from 'services/metadata/types';
import {Layout, Text} from 'components';
import {useSchema} from 'schemas/hooks';
import {ReadonlyExpressionCard} from 'widgets/metadata/readonlyExpressionCard/ReadonlyExpressionCard';
import {useExpressionTitle} from '../ExpressionCard/hooks/useExpressionTitle';

type Props = {
  expression: ExpressionV4;
};

const schemaRef: SchemaReference = Concept.expression;

const configuration: PreviewConfiguration = {
  layout: {
    partSpacing: 0.25,
  },
};

export const ExpressionItem: React.FC<Props> = ({expression}) => {
  const schema = useSchema(schemaRef);

  const title = useExpressionTitle(expression, undefined);

  return (
    <Layout py={0.5}>
      <Text variant="h4">{title}</Text>
      <ReadonlyExpressionCard
        expression={expression}
        schema={schema}
        configuration={configuration}
      />
    </Layout>
  );
};
